import it from "./it.json";
import en from "./en.json";

const LOCALES = {
  it,
  en,
};

export default LOCALES;
